/**
 * Key conventions shared by the engine, the importer and the admin screens.
 *
 * NUL (U+0000) separates category from sub-category because category and sub-category
 * names contain every other plausible separator. Keep it; do not clean it up.
 */
export const NUL = '\u0000'

export function subKey(category: string, subCategory: string): string {
  return `${category}${NUL}${subCategory}`
}

export function splitSubKey(key: string): { category: string; subCategory: string } {
  const i = key.indexOf(NUL)
  if (i < 0) return { category: key, subCategory: '' }
  return { category: key.slice(0, i), subCategory: key.slice(i + 1) }
}

/** Human-readable form of a sub-category key for labels and diffs. */
export function formatSubKey(key: string): string {
  const { category, subCategory } = splitSubKey(key)
  return subCategory ? `${category} › ${subCategory}` : category
}

/** Scoped entity keys for driver_ratings.entity_key. */
export const entityKey = {
  product: (id: string) => `product:${id}`,
  subCategory: (name: string) => `sub_category:${name}`,
  category: (name: string) => `category:${name}`,
  customer: (id: string) => `customer:${id}`,
  salesTeam: (name: string) => `sales_team:${name}`,
  territory: (name: string) => `territory:${name}`,
  /** rating keys live in a Postgres text column, which cannot hold NUL; months and territories never contain "|" */
  market: (month: string, territory: string) => `market:${month}|${territory}`,
  marketAny: (month: string) => `market:${month}|*`,
  deal: (value: string) => `deal:${value}`,
}
